<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
    <v-footer padless>
      <v-col class="text-sm-center" cols="12">
        เวอร์ชั่น {{ version }}
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    version: process.env.VUE_APP_VERSION
  }),
};
</script>
